import { cookie } from '@iyunbao/utils';

import dev from './env/dev';
import test from './env/test';
import pre from './env/pre';
import prd from './env/prd';

const configs = {
  dev: { ...dev },
  test: { ...test },
  pre: { ...pre },
  prd: { ...prd },
};

const list = ['dev', 'test', 'pre', 'prd'];

let env = list[3];

if (cookie.get('_e')) {
  env = list[cookie.get('_e')];
} else if (typeof window !== 'undefined') {
  const { host, hostname } = window.location;

  // 本地开发
  if (['127.0.0.1', 'localhost'].indexOf(hostname) >= 0) {
    // eslint-disable-next-line prefer-destructuring
    env = list[0];
  } else {
    const hostList = ['dev', 'test', 'uat'];
    let findIndex: any = null;

    hostList.map((key, i) => {
      if (new RegExp(key).test(host)) {
        findIndex = i;
      }
      return i;
    });

    env = (findIndex !== null) ? list[findIndex] : env;
  }
}

const config = configs[env];

// 获取环境
export const getEnv = () => {
  return env;
};

export default config;
